export const TEAM_HISTORY_START_COMPLETED = "overcut/teamHistory/START_COMPLETED";
export const TEAM_HISTORY_GET_COMPLETED = "overcut/teamHistory/GET_COMPLETED";
export const TEAM_HISTORY_VALIDATE_COMPLETED = "overcut/teamHistory/VALIDATE_COMPLETED";
export const TEAM_HISTORY_REVEAL_COMPLETED = "overcut/teamHistory/REVEAL_COMPLETED";
export const TEAM_HISTORY_CLEAR = "overcut/teamHistory/CLEAR";
